import { GraphQLErrors } from "@apollo/client/errors";

export const isGraphQLAccessIssue = (graphQLErrors: GraphQLErrors | undefined): boolean => {
  if (!graphQLErrors || graphQLErrors?.length === 0) {
    return false;
  }
  const payload = JSON.stringify(graphQLErrors);
  return payload.includes("Unauthorized");
};
